// extracted by mini-css-extract-plugin
export default {"methods":"PaymentMethods-module__methods--xwwtt","method":"PaymentMethods-module__method--O7Adl"};